var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileRocket3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7001 12.1171C21.3652 10.452 22.1969 8.13389 21.9604 5.81697C21.9183 5.40458 21.5954 5.08169 21.183 5.03959C18.8661 4.8031 16.548 5.63477 14.8829 7.29993L13.3472 8.83564L12.3793 8.35836L11.9629 8.18303C11.1907 7.85788 10.2897 8.03932 9.68787 8.64116L8.10301 10.226C7.92946 10.3996 7.98289 10.6903 8.20556 10.7841L9.43559 11.302L10.4035 11.7793L10.1128 12.07C9.86691 12.3159 9.8633 12.711 10.1048 12.9524L14.0476 16.8952C14.289 17.1367 14.6841 17.1331 14.93 16.8872L15.2207 16.5965L15.698 17.5644L16.2159 18.7944C16.3097 19.0171 16.6004 19.0705 16.774 18.897L18.3588 17.3121C18.9607 16.7103 19.1421 15.8093 18.817 15.0371L18.6416 14.6207L18.1644 13.6528L19.7001 12.1171Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45776 7.75L7.04237 9.16539C6.14531 10.0624 6.38055 11.6432 7.62347 12.1666L8.42606 12.5045C8.4214 13.0464 8.62278 13.5918 9.04412 14.0131L12.281 17.25H2V7.75H8.45776Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20V18.75H14V20C14 21.1046 13.1046 22 12 22H4C2.89543 22 2 21.1046 2 20Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V6.25H2V4ZM7 3.25C6.58579 3.25 6.25 3.58579 6.25 4C6.25 4.41421 6.58579 4.75 7 4.75H9C9.41421 4.75 9.75 4.41421 9.75 4C9.75 3.58579 9.41421 3.25 9 3.25H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRocket3);
export default __webpack_public_path__ + "static/media/mobile-rocket-3.1216ba06ca2534fe4089456d052287a4.svg";
export { ForwardRef as ReactComponent };